import { useRouteMatch } from 'react-router-dom'
import { Loader } from '@calendly/ui/components/loader'

import { useGetProfileLandingPageQuery } from 'root-api'
import { LandingPage } from 'components/landing_page'
import ErrorAlert from 'components/error/alert'

export const LandingPageWrapper = () => {
  const { params: { profileSlug } } = useRouteMatch()
  const { data, isLoading, isError } = useGetProfileLandingPageQuery({ slug: profileSlug })

  if (isLoading) return <Loader />

  if (isError) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  return (
    data ? <LandingPage landingPage={data} /> : <Loader />
  )
}
